// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__qPfgS","footer":"ChangeClinic_footer__23m6h"};